import { z } from 'zod';

export const deleteUncroppedUntriagedClipsResponseSchema = z.object({
  deleted: z.number(),
});

export type IDeleteUncroppedUntriagedClipsResponse = z.infer<
  typeof deleteUncroppedUntriagedClipsResponseSchema
>;
